<div class="w-100" [ngClass]="{ 'mat-ng-select': !tableStyle, 'd-flex': tableStyle }">
    <ng-select class="entity-input" [class.ng-select-fill]="!tableStyle" [formControl]="fc" [placeholder]="field.name">
        @for (entity of entities$ | async; track entity.id) {
            <ng-option [value]="entity.id">
                {{ entity.name }}
            </ng-option>
        }
    </ng-select>
    <mat-error [control]="fc"></mat-error>
</div>
@if (!entity()?.use_once && hiring$ && fcHiringId) {
    <div class="w-100" [ngClass]="{ 'mat-ng-select': !tableStyle, 'd-flex': tableStyle }">
        <ng-select
            class="entity-input"
            [class.ng-select-fill]="!tableStyle"
            [formControl]="fcHiringId"
            placeholder="Inhuur">
            @for (hire of hiring$ | async; track hire.id) {
                <ng-option [value]="hire.id">
                    {{ hire.name }}
                </ng-option>
            }
        </ng-select>
    </div>
    @if (tableStyle && fcName) {
        <textarea [formControl]="fcName" matInput placeholder="Naam" cdkTextareaAutosize rows="1"></textarea>
    } @else {
        <mat-form-field class="w-100" [subscriptSizing]="hideMatHint ? 'dynamic' : 'fixed'">
            <mat-label>Naam</mat-label>
            <textarea [formControl]="fcName" matInput placeholder="Naam" cdkTextareaAutosize rows="1"></textarea>
            <mat-error [control]="fcName"></mat-error>
        </mat-form-field>
    }
}
